export const opticalTrainsConstants = {
    SET_SELECTED_SCOPE: "SET_SELECTED_SCOPE",
    SET_SELECTED_LENS: "SET_SELECTED_LENS",
};
